import { UserTypeCellBody } from "./table";

const fields = {
    uniqueId: { label: "Unique Id", valueKey: "registrantCode", col: 1, color: "blue" },
    name: {
        label: "Student Name",
        valueKey: "name",
        col: 2,
        weight: "medium",
        ellipsis: true,
        tooltip: true,
    },
    email: { label: "Email", valueKey: "email", col: 2, ellipsis: true, tooltip: true },
    intake: { label: "Intake", valueKey: "intake", col: 1, ellipsis: true, tooltip: true },
    degreeType: {
        label: "Target Degree Types",
        valueKey: "degreeType",
        col: 2,
        ellipsis: true,
        tooltip: true,
    },
    program: { label: "Target Programs", valueKey: "program", col: 2, ellipsis: true, tooltip: true },
    university: { label: "University", valueKey: "university", col: 1, ellipsis: true, tooltip: true },
    notes: {
        label: "Notes",
        valueKey: "notes",
        col: 2,
        ellipsis: true,
        tooltip: true,
        tooltipValueKey: "formattedNotes",
    },
    studentType: { label: "Student Type", valueKey: "type", col: 2, Component: UserTypeCellBody },
};

export const counsellorCols = [
    { ...fields.uniqueId },
    { ...fields.name, col: 1 },
    { ...fields.intake },
    { ...fields.degreeType },
    { ...fields.program },
    { ...fields.university },
    { ...fields.notes },
    { ...fields.studentType },
];

export const universityCols = [
    { ...fields.uniqueId },
    { ...fields.name },
    { ...fields.email },
    { ...fields.intake },
    { ...fields.degreeType },
    { ...fields.program },
    { ...fields.notes },
];

export const textValues = {
    noDataText: "No students found",
};
